import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import * as schemas from "../../../assets/schemas/schemas";
import { ActionButton } from "../../common/Buttons/Buttons";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import useIvaCalculation from "../../../hooks/useIvaCalculation";
import { useHistory } from "react-router-dom";
import { Header } from "../../common/Header/Header";
import { LoadSpinner } from "../../common/LoadSpinner/LoadSpinner";
import {
  ScheduleServicesModal,
  MapModal,
  CancelCaseModal,
  CreateAVModal,
  FollowUpModal,
  MessageAVModal,
  MessageLocksmithModal,
  MessageTowModal,
  BatterySaleModal,
} from "../../common/Modals/Modals";
import { membershipService } from "../../../services/membershipService";
import { papService } from "../../../services/papService";
import { servicesService } from "../../../services/servicesService";
import { stagesService } from "../../../services/stagesService";
import { garageService } from "../../../services/garageService";
import { caseService } from "../../../services/caseService";
import { usersService } from "../../../services/usersService";
import { providersService } from "../../../services/providersService";
import { faultsService } from "../../../services/faultsService";
import { statesService } from "../../../services/statesService";
import { productService } from "../../../services/productService";
import { batteryService } from "../../../services/batteryService.js";
import { vehicleService } from "../../../services/vehicleService";
import { membershipProductsService } from "../../../services/membershipProductsService";
import { rateService } from "../../../services/rateService";
import { notify } from "../../../assets/helpers/toast";
import { CraneCounter } from "../../miscelaneos/CraneCounter/CraneCounter.jsx";
import moment from "moment";
import {
  clientTypes,
  notFound,
  particularServices,
  afiliatedServices,
  membershipStatus,
  PapStatus,
  PaymentStatusOptions,
  PaymentStatus,
  addressEnum,
  addressStatus,
  referenceLocation,
  afiliatedAddressOptions,
  paymentMethods as metodosDePago,
  resolveCancelReasonType,
  saleChannelCodes,
} from "../../../assets/helpers/options";
import { Input } from "../../common/Forms/Input/Input";
import {
  ClientDetail,
  IncidenceSearch,
  AvailableServices,
  SelectedServices,
  IncidenceDetailForm,
  HandleCaseButtons,
  ServiceHistory,
  ClientDetailSectionForm,
} from "./IncidenceSections";
import "./Incidence.scss";
import {
  capitalize,
  filterParams,
  exists,
  getOption,
  isValidMongoId,
  parseNull,
  filterOption,
  filterOptionById,
  addressToGeoCode,
  validatePaymentRefLenght,
  isLocksmithService,
} from "../../../assets/helpers/funciones";
import {
  createLocksmithService,
  setLocksmithPaymentDefaults,
} from "../../../assets/helpers/locksmithPayment";
import { splitPhone } from "../../../assets/helpers/parsers.js";
import { maxEscortKm } from "../../../assets/helpers/variables";
import { cashReceiverService } from "../../../services/cashReceiverService.js";
import {
  parseIncidenceTemplate,
  findOptionLoose,
} from "../../../assets/helpers/parseIncidenceTemplate";
import {
  applyCasePhoneFields,
  formatPhoneForInput,
} from "../../../assets/helpers/phoneHelpers";

// Statuses that allow creating a new incidence. Regular memberships and PAP
// records use disjoint enums (a record exposes either `membershipStatus` OR
// `papStatus`, never both), so we route by record type before checking. This
// also avoids the `[undefined, ...].includes(undefined)` pitfall that made the
// previous inline check return true for any non-PAP membership — including
// expired or canceled ones.
const ALLOWED_MEMBERSHIP_STATUSES = [
  membershipStatus.ACTIVO,
  membershipStatus["EN ESPERA"],
  membershipStatus["ESPERANDO VENCIMIENTO"],
  membershipStatus["POR RENOVACION"],
  membershipStatus.PENDIENTE,
  membershipStatus.RENOVADO,
];
const ALLOWED_PAP_STATUSES = [PapStatus.ACTIVE, PapStatus.TO_RENEW];

const canCreateIncidence = (membership) => {

  if (!membership || membership === notFound) return false;

  const status = membership?.status;
  if (!status) return false;

  // Validate PAP status
  if (membership?.papClient) {
    if (status) {
      return ALLOWED_PAP_STATUSES.includes(status);
    }
  }

  return ALLOWED_MEMBERSHIP_STATUSES.includes(status.membershipStatus);
};

export const AffiliatedIncidence = () => {
  const { t } = useTranslation();

  const [statesOptions, setStatesOptions] = useState([]);
  const [originCitiesOptions, setOriginCitiesOptions] = useState([]);
  const [cashReceiverOptions, setCashReceiverOptions] = useState([]);
  const [supervisors, setSupervisors] = useState([]);

  const [destinycitiesOptions, setDestinyCitiesOptions] = useState([]);
  const [faultsOptions, setFaultsOptions] = useState([]);
  const [providersOptions, setProvidersOptions] = useState([]);
  const [recommendedProvidersOptions, setRecommendedProvidersOptions] =
    useState([]);
  const prevWithOutDestinyRef = useRef(false);
  const [bsDisabled, setbsDisabled] = useState(true);
  const [addressOption, setAddressOption] = useState([]);
  const [showCancelService, setShowCancelService] = useState({
    show: false,
    caseSelected: "",
    cancelOptions: [],
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setValue: setValue2,
    getValues: getValues2,
    resetField: resetField2,
    reset: reset2,
    watch: watch2,
    setError: setError2,
    control: control2,
  } = useForm({
    resolver: yupResolver(schemas.CreateIncidenceSchema(t)),
  });

  const {
    register: register3,
    handleSubmit: handleSubmit3,
    formState: { errors: errors3 },
    setValue: setValue3,
    getValues: getValues3,
    resetField: resetField3,
    watch: watch3,
    setError: setError3,
  } = useForm({
    resolver: yupResolver(schemas.CreateAVFormSchema(t)),
  });

  const {
    register: register4,
    handleSubmit: handleSubmit4,
    formState: { errors: errors4 },
    control: control4,
  } = useForm({
    resolver: yupResolver(schemas.ScheduleServiceSchema(t)),
  });

  const {
    register: register5,
    handleSubmit: handleSubmit5,
    formState: { errors: errors5 },
    setValue: setValue5,
    watch: watch5,
    control: control5,
  } = useForm({
    resolver: yupResolver(schemas.createFollowUpSchema(t)),
  });

  const {
    register: register6,
    handleSubmit: handleSubmit6,
    setValue: setValue6,
    watch: watch6,
    formState: { errors: errors6 },
  } = useForm({
    resolver: yupResolver(schemas.createFollowUpSchema(t)),
  });

  const {
    register: register7,
    watch: watch7,
    formState: { errors: errors7 },
    reset: reset7,
  } = useForm({
    resolver: yupResolver(schemas.RideryTowOtpSchema(t)),
  });

  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [showErrorAPI, setShowErrorAPI] = useState(false);
  const [showSchedule, setShowSchedule] = useState({
    battery: false,
    show: false,
  });
  const [dollarRate, setDollarRate] = useState("");
  const [reason, setReason] = useState("");
  const [showSMSModal, setShowSMSModal] = useState({
    isOpen: false,
    provider: "",
  });
  const [showSMSTowModal, setShowSMSTowModal] = useState({
    isOpen: false,
    provider: "",
  });
  const [batterySaleModal, setBatterySaleModal] = useState({
    isOpen: false,
    provider: "",
  });
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [filteredMethods, setFilteredMethods] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [selectedBike, setSelectedBike] = useState("");
  const [caseInfo, setCaseInfo] = useState();
  const [fileUploaded, setFileUploaded] = useState([]);
  const [availableServices, setAvailableServices] = useState({
    selected: "",
    available: [],
  });
  // Cerrajeria se presta con un proveedor recomendado en lugar de un motorizado
  const selectableProviders =
    availableServices?.selected?.code === afiliatedServices?.LOCKSMITH
      ? recommendedProvidersOptions
      : providersOptions;
  const [rideryOtpStatus, setRideryOtpStatus] = useState(0);
  const [showCraneCounterModal, setShowCraneCounterModal] = useState({
    show: false,
    src: "",
    zoom: 1,
  });
  const [openPayModal, setOpenPayModal] = useState(false);
  const [followUpModal, setFollowUpModal] = useState(false);
  const [serviceHistory, setServiceHistory] = useState([]);
  const [errorsDropzone, setErrorsDropzone] = useState({});
  const [cashBackImage, setCashBackImage] = useState([]);
  const [batteryOptions, setBatteryOptions] = useState([]);
  const [clientSearch, setClientSearch] = useState({
    searchParam: "",
    options: [],
    isOpen: false,
    selected: "",
    exists: true,
  });

  const originRef = useRef();
  const destinyRef = useRef();

  const [_case, setCase] = useState({
    selected: "",
  });
  const [origin, setOrigin] = useState({
    lat: "",
    lng: "",
    address: "",
  });
  const [destiny, setDestiny] = useState({
    lat: "",
    lng: "",
    address: "",
  });

  const [route, setRoute] = useState({
    distance: "",
    time: "",
  });

  let history = useHistory();
  // Function that handles the logout request

  const scheduleService = handleSubmit4(async (data) => {
    let fecha = moment(data?.date).format("YYYY-MM-DD");
    let date = new Date(fecha + "T" + data?.time);
    date = moment(date).format();

    let dataToPost = {
      date: date,
      productId: availableServices?.selected?._id,
      reason: reason,
    };

    if (
      !reason &&
      [afiliatedServices?.crane, particularServices?.crane]?.includes(
        availableServices?.selected?.code
      )
    ) {
      notify("Debe indicar un motivo de selección de la grúa", "info");
      return null;
    }

    if (!isLoading) {
      setIsloading(true);
      caseService
        .scheduleCase(filterParams(dataToPost), _case?.selected?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Servicio agendado con exito`, "success");

            if (
              [
                afiliatedServices?.craneExtended,
                afiliatedServices?.crane,
                particularServices?.crane,
              ].includes(availableServices?.selected?.code)
            ) {
              history.push("/services");
              setIsloading(false);
            } else {
              openSMSModal();
              setShowSchedule({
                show: true,
                battery: false,
              });
              setIsloading(false);
            }
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const startFolloUpService = handleSubmit5(async (data) => {
    let fecha = moment(data?.tripDate).format("YYYY-MM-DD");
    let date = new Date(fecha + "T" + data?.contactTime);
    date = moment(date).format();

    let dataToPost = {
      tripDate: date,
      frequency: data?.frequency,
      expectedTime: data?.expectedTime,
    };

    if (!isLoading) {
      setIsloading(true);
      caseService
        .serviceTrip(
          dataToPost,
          // xavailableServices?.selected?._id,
          _case?.selected?._id
        )
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            setIsloading(false);
            notify(`Seguimiento creado con exito`, "success");
            setValue5("amount", response?.data?.tripTracking?.amount);

            for (
              let i = 0;
              i < response?.data?.tripTracking?.trackings?.length;
              i++
            ) {
              if (response?.data?.tripTracking?.trackings[i]?.scheduled) {
                setValue5(`tracking${i}`, "");
                setValue5(
                  `tracking${i}`,
                  moment(
                    response?.data?.tripTracking?.trackings[i]?.scheduled
                  )?.format("HH:mm")
                );
              }
            }
            setValue5(`created`, response?.data?._id);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const editFolloUpService = handleSubmit5(async (data) => {
    let fecha = moment(data?.tripDate).format("YYYY-MM-DD");
    let date = new Date(fecha + "T" + data?.contactTime);
    date = moment(date).format();

    let dataToPost = {
      tripDate: date,
      frequency: data?.frequency,
      expectedTime: data?.expectedTime,
    };

    if (!isLoading) {
      setIsloading(true);
      caseService
        .editServiceTrip(dataToPost, watch5(`created`))
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            setIsloading(false);
            notify(`Seguimiento editado con exito`, "success");
            setValue5("amount", response?.data?.tripTracking?.amount);

            for (
              let i = 0;
              i < response?.data?.tripTracking?.trackings?.length;
              i++
            ) {
              if (response?.data?.tripTracking?.trackings[i]?.scheduled) {
                setValue5(`tracking${i}`, "");
                setValue5(
                  `tracking${i}`,
                  moment(
                    response?.data?.tripTracking?.trackings[i]?.scheduled
                  )?.format("HH:mm")
                );
              }
            }
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const acceptFollowing = () => {
    history.push("/services");
  };

  const restartTracking = () => {
    for (let i = 0; i < 5; i++) {
      setValue5(`tracking${i}`, "");
    }
    setValue5(`amount`, "");
  };

  const validateAddresses = (data) => {
    if (!data?.withOutDestinyAddress && !data?.destinyAddress) {
      notify("Debe seleccionar una dirección de destino", "error");
      return false;
    }
    if (!data?.originAddress) {
      notify("Debe seleccionar una dirección de origen", "error");
      return false;
    } else return true;
  };

  const validateActiveMembership = () => {
    vehicleService
      .validateActiveMembership(watch2("vehiclePlate"))
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          if (response?.data?.membership) {
            notify(
              `El vehiculo seleccionado tiene una membresia activa`,
              "info"
            );
            setValue2("businessAlly", "");

            setValue2("firstName", "");
            setValue2("lastName", "");
            setValue2("vehicleBrand", "");
            setValue2("vehicleModel", "");
            setValue2("vehicleColor", "");
            setValue2("vehiclePlate", "");
            setValue2("vehicleYear", "");
            setValue2("phone", "");
            setValue2("withOutDestinyAddress", false);
            setValue2("originLocationStatus", addressEnum.OTHER);
            getMembershipById(response?.data?.membership?._id);
            return true;
          } else {
            return false;
          }
        }
      })
      .catch((error) => {
        setIsloading(false);
      });
  };

  const createAffiliatedCase = handleSubmit2(async (data) => {
    console.log("data:", data);

    let dataToPost = applyCasePhoneFields({ ...data });

    dataToPost.originLatitude = origin?.lat.toString();
    dataToPost.originLongitude = origin?.lng.toString();

    dataToPost.destinyLatitude = destiny?.lat.toString();
    dataToPost.destinyLongitude = destiny?.lng.toString();

    if (watch2("withOutDestinyAddress")) {
      const latLng = await addressToGeoCode(originRef.current.value);
      dataToPost.originLatitude = latLng?.lat.toString();
      dataToPost.originLongitude = latLng?.lng.toString();
    }

    if (data?.segViaje) {
      dataToPost.isTripService = true;
    }
    if (isValidMongoId(dataToPost?.originLocationStatus)) {
      dataToPost.originLocationId = watch2("originLocationStatus");
      dataToPost.originLocationStatus = addressEnum?.GARAGE;
    }

    if (isValidMongoId(dataToPost?.destinyLocationStatus)) {
      dataToPost.destinyLocationId = watch2("destinyLocationStatus");
      dataToPost.destinyLocationStatus = addressEnum?.GARAGE;
    }

    if (data?.withOutDestinyAddress) {
      setValue2("originAddress", originRef.current.value);
      dataToPost.originAddress = originRef.current.value;
    }

    if (!validateAddresses(dataToPost)) {
      return null;
    }

    dataToPost.membership = clientSearch?.selected?._id;

    if (clientSearch?.selected?.papClient?.firstName) {
      if (validateActiveMembership()) return null;

      dataToPost.papMembership = clientSearch?.selected?._id;
      dataToPost.vehicleData = {
        firstName: data?.firstName,
        lastName: data?.lastName,
        brand: data?.vehicleBrand,
        model: data?.vehicleModel,
        color: data?.vehicleColor,
        plate: data?.vehiclePlate,
        year: data?.vehicleYear,
        phonePrefix: dataToPost?.phonePrefix,
        phoneNumber: dataToPost?.phoneNumber,
      };
      delete dataToPost?.membership;
      delete dataToPost?.businessAlly;
    }

    if (clientSearch?.selected?.code?.code === "F2") {
      dataToPost.vehicleData = {
        firstName: data?.firstName || clientSearch?.selected?.customer?.firstName,
        lastName: data?.lastName || clientSearch?.selected?.customer?.lastName,
        brand: data?.vehicleBrand || clientSearch?.selected?.vehicle?.brandId,
        model: data?.vehicleModel || clientSearch?.selected?.vehicle?.modelId,
        color: data?.vehicleColor || clientSearch?.selected?.vehicle?.color,
        plate: data?.vehiclePlate || clientSearch?.selected?.vehicle?.plate,
        year: data?.vehicleYear || clientSearch?.selected?.vehicle?.year,
        phonePrefix: clientSearch?.selected?.customer?.phonePrefix,
        phoneNumber: clientSearch?.selected?.customer?.phoneNumber,
      };
    }

    // Datos utilizados unicamente para manejar logica del form
    delete dataToPost?.isOriginBasement;
    delete dataToPost?.withOutDestinyAddress;
    delete dataToPost?.segViaje;
    delete dataToPost?.firstName;
    delete dataToPost?.lastName;
    delete dataToPost?.vehicleBrand;
    delete dataToPost?.vehicleModel;
    delete dataToPost?.vehicleColor;
    delete dataToPost?.vehiclePlate;
    delete dataToPost?.vehicleYear;
    delete dataToPost?.phonePrefix;
    delete dataToPost?.phoneNumber;

    if (!isLoading) {
      setIsloading(true);
      caseService
        .createCase(filterParams(dataToPost))
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Caso creado con exito`, "success");
            setCase((prevState) => {
              return {
                ...prevState,
                selected: response?.data?.case,
              };
            });

            if (clientSearch?.selected?.papClient?.firstName) {
              getAvailablePAPProducts(response?.data?.case?._id);
            } else {
              getAvailableProducts(response?.data?.case);
            }
            setIsloading(false);

            originRef.current.value = watch2("originAddress");
            destinyRef.current.value = watch2("destinyAddress");
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const editAffiliatedCase = handleSubmit2(async (data) => {
    let dataToPost = applyCasePhoneFields({ ...data });
    dataToPost.originLatitude = origin?.lat.toString();
    dataToPost.originLongitude = origin?.lng.toString();

    dataToPost.destinyLatitude = destiny?.lat.toString();
    dataToPost.destinyLongitude = destiny?.lng.toString();

    if (watch2("withOutDestinyAddress")) {
      const latLng = await addressToGeoCode(originRef.current.value);
      dataToPost.originLatitude = latLng?.lat.toString();
      dataToPost.originLongitude = latLng?.lng.toString();
    }

    if (isValidMongoId(dataToPost?.originLocationStatus)) {
      dataToPost.originLocationId = watch2("originLocationStatus");
      dataToPost.originLocationStatus = addressEnum?.GARAGE;
    }

    if (isValidMongoId(dataToPost?.destinyLocationStatus)) {
      dataToPost.destinyLocationId = watch2("destinyLocationStatus");
      dataToPost.destinyLocationStatus = addressEnum?.GARAGE;
    }

    if (data?.withOutDestinyAddress) {
      setValue2("originAddress", originRef.current.value);
      dataToPost.originAddress = originRef.current.value;
    }

    if (!validateAddresses(dataToPost)) {
      return null;
    }

    // Datos utilizados unicamente para manejar logica del form
    delete dataToPost?.isOriginBasement;
    delete dataToPost?.withOutDestinyAddress;
    delete dataToPost?.segViaje;

    dataToPost.membership =
      clientSearch?.selected?._id ||
      _case?.selected?.membership?._id ||
      _case?.selected?.membership;

    const isPapCase =
      clientSearch?.selected?.papClient?.firstName || _case?.selected?.papMembership;

    if (isPapCase) {

      dataToPost.papMembership =
        clientSearch?.selected?._id ||
        _case?.selected?.papMembership?._id ||
        _case?.selected?.papMembership;

      dataToPost.vehicleData = {
        firstName: data?.firstName,
        lastName: data?.lastName,
        brand: data?.vehicleBrand,
        model: data?.vehicleModel,
        color: data?.vehicleColor,
        plate: data?.vehiclePlate,
        year: data?.vehicleYear,
        phonePrefix: dataToPost?.phonePrefix,
        phoneNumber: dataToPost?.phoneNumber,
      };
      delete dataToPost?.membership;
      delete dataToPost?.businessAlly;
    }

    // if (clientSearch?.selected?.code?.code === "F2") {
    //   dataToPost.vehicleData = {
    //     firstName: data?.firstName || clientSearch?.selected?.customer?.firstName,
    //     lastName: data?.lastName || clientSearch?.selected?.customer?.lastName,
    //     brand: data?.vehicleBrand || clientSearch?.selected?.vehicle?.brandId,
    //     model: data?.vehicleModel || clientSearch?.selected?.vehicle?.modelId,
    //     color: data?.vehicleColor || clientSearch?.selected?.vehicle?.color,
    //     plate: data?.vehiclePlate || clientSearch?.selected?.vehicle?.plate,
    //     year: data?.vehicleYear || clientSearch?.selected?.vehicle?.year,
    //     phonePrefix: clientSearch?.selected?.customer?.phonePrefix,
    //     phoneNumber: clientSearch?.selected?.customer?.phoneNumber,
    //   };
    // }

    delete dataToPost?.firstName;
    delete dataToPost?.lastName;
    delete dataToPost?.vehicleBrand;
    delete dataToPost?.vehicleModel;
    delete dataToPost?.vehicleColor;
    delete dataToPost?.vehiclePlate;
    delete dataToPost?.vehicleYear;
    delete dataToPost?.phonePrefix;
    delete dataToPost?.phoneNumber;

    if (!isLoading) {
      setIsloading(true);
      caseService
        .editCase(filterParams(dataToPost), _case?.selected?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Caso editado con exito`, "success");
            if (isPapCase) {
              getAvailablePAPProducts(response?.data?.case?._id);
            } else {
              getAvailableProducts(response?.data?.case);
            }
            setCase((prevState) => {
              return {
                ...prevState,
                selected: response?.data?.case,
              };
            });
            setIsloading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  // Recalculate distance if origin or destny changes
  const forceRecalulateDistance = (e, value) => {
    if (value === addressStatus?.ORIGIN) {
      setValue2("originLocationStatus", addressEnum.OTHER);
    }
    if (value === addressStatus?.DESTINY) {
      setValue2("destinyLocationStatus", addressEnum.OTHER);
    }

    setValue2("caseKm", "");
  };

  const handleSegViaje = () => {
    setValue2("customerFailureReason", "");

    let [seguimiento] = availableServices?.available.filter(
      (a) => a.code === afiliatedServices?.SEG_VIAJE
    );
    if (watch2("segViaje") && seguimiento) {
      selectService(seguimiento);
    }

    if (watch2("segViaje")) {
      setValue2("withOutDestinyAddress", false);
    }

    if (!watch2("segViaje")) {
      unSelectService();
    }
  };

  const openFollowUpModal = () => {
    setFollowUpModal(true);
    setValue5("expectedTime", route?.time);
  };

  const clearDestinyData = () => {
    resetField2("destinyLocationStatus");
    resetField2("destinyState");
    resetField2("destinyCity");
    resetField2("destinyAddress");
  };

  const clearThirdPartyData = () => {
    resetField2("thirdPartyParticularCustomerName");
    resetField2("thirdPartyParticularCustomerLastName");
    resetField2("thirdPartyServicePhonePrefix");
    resetField2("thirdPartyServicePhoneNumber");
    resetField2("thirdPartyVehicleBrand");
    resetField2("thirdPartyVehicleModel");
    resetField2("thirdPartyVehicleColor");
    resetField2("thirdPartyVehicleYear");
    resetField2("thirdPartyVehiclePlate");
  };

  // Precarga el formulario de casos con la info por defecto
  const preloadCaseForm = (membership) => {
    // setValue2('contactNumberPrefix', membership?.customer?.phonePrefix);
    // setValue2('contactNumber', membership?.customer?.phoneNumber);
    setValue2("originLocationStatus", afiliatedAddressOptions[2]?._id);
    setValue2("isOriginBasement", false);
    setValue2("destinyLocationStatus", afiliatedAddressOptions[2]?._id);

    setValue2("vehicleYear", membership?.vehicle?.year);
  };

  const preloadPaPCaseForm = (membership) => {
    const { phonePrefix, phoneNumber } = splitPhone(membership?.papClient);

    setValue2("firstName", membership?.papClient?.firstName);
    setValue2("lastName", membership?.papClient?.lastName);
    setValue2("phone", formatPhoneForInput(phonePrefix, phoneNumber));
    setValue2("withOutDestinyAddress", true);

    setValue2("originLocationStatus", afiliatedAddressOptions[2]?._id);
    setValue2("isOriginBasement", false);
  };

  const getMembershipById = (membershipId) => {
    membershipService
      .getMembershipById(membershipId, "operations")
      .then((response) => {
        if (response.status === 200) {
          setClientSearch((prevState) => {
            return {
              ...prevState,
              selected: response?.data?.membership,
              isOpen: false,
            };
          });
          getLastServices(response?.data?.membership?._id);
          preloadCaseForm(response?.data?.membership);
          // So PAP validations are not made
          setValue2("businessAlly", "");
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };
  const getPAPMembershipById = (membershipId) => {
    papService
      .getMembershipById(membershipId, "operations")
      .then((response) => {
        if (response.status === 200) {
          setClientSearch((prevState) => {
            return {
              ...prevState,
              selected: response?.data?.papMembership,
              isOpen: false,
            };
          });
          getPAPLastServices(response?.data?.papMembership?._id);
          preloadPaPCaseForm(response?.data?.papMembership);
          // So PAP validations are made
          setValue2("businessAlly", response?.data?.papMembership?._id);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const selectClient = (option) => {
    if (option?.papClient) {
      getPAPMembershipById(option?._id);
    } else {
      getMembershipById(option?.membershipId);
    }
  };

  const handleClientSearchChange = (e) => {
    const { value, name } = e.target;
    // Reset the form / case / services only on the transition from a selected
    // client back to typing. Running reset2() on every keystroke makes the
    // input feel laggy because react-hook-form emits updates for every
    // registered field on each call.
    if (clientSearch?.selected) {
      reset2();
      setCase({ selected: "" });
      setAvailableServices({
        selected: "",
        available: [],
      });
    }
    setClientSearch((prevState) => {
      return {
        ...prevState,
        [name]: value,
        selected: "",
        // Hide stale results while the user is still typing — they'll be
        // re-opened the moment Buscar/Enter fires the search.
        isOpen: false,
      };
    });
  };

  const getMembership = (searchParam) => {
    if (!searchParam) {
      notify("Ingresar campos para realizar la busqueda", "info");
      return Promise.resolve(null);
    }
    setIsloading(true);
    return membershipService
      .getMembership(searchParam)
      .then((response) => {
        if (response.status === 200) {
          const combined = [
            ...response?.data?.papMemberships,
            ...response?.data?.memberships,
          ];
          setClientSearch((prevState) => {
            return {
              ...prevState,
              options: combined,
              isOpen: true,
            };
          });
          setIsloading(false);
          return combined;
        } else {
          notify(`${response.message}`, "error");
          setIsloading(false);
          return null;
        }
      })
      .catch((error) => {
        setIsloading(false);
        return null;
      });
  };

  const getAvailableProducts = (_case) => {
    const params = {
      membershipId: _case?.membership?._id || _case?.membership,
      originCityId: _case?.originCity?._id || _case?.originCity,
      distance: parseFloat(_case?.caseKm),
      caseId: watch2("thirdPartyService") ? _case?._id : "",
    };

    membershipProductsService
      .getAvailableProducts(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          let availableServices = response?.data?.availableServices;
          // Destiny address is required for these services
          if (watch2("withOutDestinyAddress")) {
            availableServices = availableServices.filter(
              (a) =>
                ![
                  particularServices.crane,
                  afiliatedServices.crane,
                  particularServices.ESCORT,
                  afiliatedServices.ESCORT,
                ].includes(a?.code)
            );
          }

          if (parseFloat(watch2("caseKm")) > maxEscortKm) {
            availableServices = availableServices.filter(
              (a) =>
                ![particularServices.ESCORT, afiliatedServices.ESCORT].includes(
                  a?.code
                )
            );
          }
          setAvailableServices((prevState) => {
            return {
              ...prevState,
              selected: "",
              available: [...availableServices],
            };
          });
          let [seguimiento] = availableServices.filter(
            (a) => a.code === afiliatedServices?.SEG_VIAJE
          );

          if (watch2("segViaje") && seguimiento) {
            availableServices.forEach((e) => {
              e.selected = false;
              if (e._id === seguimiento._id) {
                e.selected = true;
              }

              setAvailableServices((prevState) => {
                return {
                  ...prevState,
                  selected: seguimiento,
                  available: [...availableServices],
                };
              });
            });
          } else {
          }
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const getAvailablePAPProducts = (caseid) => {
    membershipProductsService
      .getAvailablePAPProducts(caseid)
      .then((response) => {
        if (response.status === 200) {
          let availableServices = response?.data?.products;
          if (watch2("withOutDestinyAddress")) {
            availableServices = availableServices.filter(
              (a) =>
                ![particularServices.crane, afiliatedServices.crane].includes(
                  a?.code
                )
            );
          }
          setAvailableServices((prevState) => {
            return {
              ...prevState,
              selected: "",
              available: [...availableServices],
            };
          });
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const getCaseDetail = () => {
    caseService
      .getCaseById(_case?.selected?._id)
      .then((response) => {
        if (response.status === 200) {
          setCaseInfo(response?.data?.case);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const openSMSModal = () => {
    getDollarRate();
    let [provider] = selectableProviders.filter((p) => p?._id === selectedBike);
    setShowSMSModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showSMSModal?.isOpen,
        provider: provider,
      };
    });
  };

  const openSMSTowModal = () => {
    setShowSMSTowModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showSMSTowModal?.isOpen,
      };
    });
  };

  // Primer servicio de grúa de un afiliado del canal Ridery: se exige OTP
  // independientemente de la escala de precio. "Primer servicio" se mide por
  // el historial de towServices de la membresía (obtenido vía
  // getMembershipById/"operations" al seleccionar el cliente), no por los
  // servicios del caso actual.
  const isRideryFirstTowService =
    saleChannelCodes?.RIDERY?.includes(
      clientSearch?.selected?.saleChannel?.shortName
    ) && !clientSearch?.selected?.towServices?.length;

  const requiresRideryOtp =
    [
      afiliatedServices?.crane,
      afiliatedServices?.craneExtended,
      particularServices?.crane,
    ].includes(availableServices?.selected?.code) && isRideryFirstTowService;

  useEffect(() => {
    if (requiresRideryOtp) {
      setRideryOtpStatus((prevStatus) => (prevStatus === 0 ? 1 : prevStatus));
    } else {
      setRideryOtpStatus(0);
      reset7();
    }
  }, [requiresRideryOtp, _case?.selected?._id, reset7]);

  const requestRideryOtp = () => {
    if (!reason) {
      notify("Debe indicar un motivo de selección de la grúa", "info");
      return null;
    }

    if (!isLoading && _case?.selected?._id) {
      setIsloading(true);
      servicesService
        .requestRideryTowOtp({
          case: _case?.selected?._id,
          reason: reason,
        })
        .then((response) => {
          if (response.status === 200) {
            notify("Codigo generado con exito y enviado a su correo", "info");
          } else {
            notify(`${response.message}` || "error", "error");
          }
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  };

  const validateRideryOtp = () => {
    const data = {
      case: _case?.selected?._id,
      code: watch7("code"),
    };

    if (!isLoading && _case?.selected?._id) {
      setIsloading(true);
      servicesService
        .validateRideryTowOtp(data)
        .then((response) => {
          if (response.status === 200) {
            notify("Codigo validado con exito ", "info");
            setRideryOtpStatus(2);
          } else {
            notify(`${response.message}` || "error", "error");
          }
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  };

  const handleBatteryChange = () => {
    if (watch6("battery")) {
      setValue6(
        "price",
        filterOptionById(batteryOptions, watch6("battery")).price
      );
    } else {
      setValue6("price", "");
    }
  };

  const handleScheduleBattery = (serviceCode) => {
    if (
      [
        afiliatedServices?.BATT_SALE,
        particularServices?.BATT_SALE_PART,
      ].includes(availableServices?.selected?.code)
    ) {
      setShowSchedule({
        ...showSchedule,
        battery: true,
      });
      handleBatterySaleModal();
    } else {
      setShowSchedule({
        ...showSchedule,
        battery: false,
        show: true,
      });
    }
  };

  const getBattery = () => {
    const params = {
      brandId: clientSearch?.selected?.vehicle?.brandId,
      modelId: clientSearch?.selected?.vehicle?.modelId,
      year: clientSearch?.selected?.vehicle?.year,
    };

    batteryService
      .getAvailable(params)
      .then((response) => {
        if (response.status === 200) {
          let options = response?.data?.available.map((e) => {
            const isRecommended = response?.data?.recommendation.some(
              (r) => r._id === e._id
            );
            return {
              _id: e?._id,
              name: `${e?.enterprise} ${e?.name}  ${e?.price}$ ${isRecommended ? "(Recomendado)" : ""
                }`,
              price: e?.price,
            };
          });
          setBatteryOptions(options);
          setValue6("battery", response?.data?.recommendation[0]?._id);
          setValue6("price", response?.data?.recommendation[0]?.price);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const acceptBatterySale = handleSubmit6(async (data) => {
    handleBatterySaleModal();
    if (showSchedule.battery) {
      setShowSchedule({
        ...showSchedule,
        show: true,
      });
      return null;
    }
    openSMSModal();
  });

  const handleBatterySaleModal = () => {
    if (!batterySaleModal?.isOpen) {
      getBattery();
    }

    setBatterySaleModal((prevState) => {
      return {
        ...prevState,
        isOpen: !batterySaleModal?.isOpen,
      };
    });
  };

  const setBsRate = (e) => {
    const { name, value } = e?.target;

    // Replocate Accholder in referene only if the method is Zelle or Paypal
    let method = name?.replace("accHolder", "method");
    let reference = name?.replace("accHolder", "reference");

    const selectedMethod = filterOptionById(paymentMethods, watch3(method));
    if (
      [metodosDePago.ZELLE, metodosDePago.PAYPAL].includes(selectedMethod?.name)
    ) {
      setValue3(reference, watch3(name));
    }

    if (!dollarRate) {
      setbsDisabled(false);
    }

    if (name.includes("amount")) {
      setValue3(
        name.replace("amount", "amountBsS"),
        (value * dollarRate).toFixed(2)
      );
    }

    if (/^method\d+$/.test(name)) {
      const slotIndex = name.replace("method", "");
      setValue3(`skipApiValidationError${slotIndex}`, false);
    }
  };

  const getDollarRate = () => {
    rateService
      .getDollarRate()
      .then((response) => {
        if (response.status === 200) {
          setDollarRate(response?.data?.rate);
          setbsDisabled(true);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const selectService = (service) => {
    //SI es seguimiento no se toma la falla
    if (service?.code === afiliatedServices?.SEG_VIAJE) {
      setValue2("segViaje", true);
      setValue2("customerFailureReason", "");
      setError2("customerFailureReason", { type: "custom", message: "" });
    } else {
      setValue2("segViaje", false);
    }

    // La averia es obligatoria si el servicio no es de seguimiento
    if (
      service?.code !== afiliatedServices?.SEG_VIAJE &&
      (!_case?.selected?.customerFailureReason ||
        !watch2("customerFailureReason"))
    ) {
      notify("Debe reportar una avería y actualizar el caso", "error");
      setError2("customerFailureReason", {
        type: "custom",
        message: "Obligatorio",
      });
      return null;
    }

    // Cerrajeria no requiere direccion destino y la presta un proveedor recomendado
    if (
      service?.code === afiliatedServices?.LOCKSMITH &&
      availableServices?.selected?.code !== afiliatedServices?.LOCKSMITH
    ) {
      prevWithOutDestinyRef.current = watch2("withOutDestinyAddress");
      setValue2("withOutDestinyAddress", true);
      getRecommendedProviders();
    } else if (
      service?.code !== afiliatedServices?.LOCKSMITH &&
      availableServices?.selected?.code === afiliatedServices?.LOCKSMITH
    ) {
      setValue2("withOutDestinyAddress", prevWithOutDestinyRef.current);
    }

    getCaseDetail();
    let services = availableServices?.available;
    setSelectedBike("");
    services.forEach((e) => {
      e.selected = false;
      if (e._id === service._id) {
        e.selected = true;
      }

      setAvailableServices((prevState) => {
        return {
          ...prevState,
          selected: service,
          available: [...services],
        };
      });
    });
  };

  const getStates = () => {
    statesService
      .getStates()
      .then((response) => {
        if (response.status === 200) {
          setStatesOptions(response?.data?.states);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const getCities = (e, reference) => {
    forceRecalulateDistance();
    statesService
      .getCities(e?.target?.value ? e?.target?.value : e)
      .then((response) => {
        if (response.status === 200) {
          if (reference === referenceLocation?.ORIGIN) {
            setOriginCitiesOptions(response?.data?.cities);
          }
          if (reference === referenceLocation?.DESTINY) {
            setDestinyCitiesOptions(response?.data?.cities);
          }
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
    return true;
  };

  const getGarageLocation = () => {
    garageService
      .getGarageAddress()
      .then((response) => {
        if (response.status === 200) {
          setAddressOption([
            { name: addressEnum?.OWN, _id: addressEnum?.OWN },
            ...response?.data?.addresses,
            { name: addressEnum?.OTHER, _id: addressEnum?.OTHER },
          ]);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const getFaults = () => {
    let params = {
      isActive: true,
      limit: 1000,
    };
    faultsService
      .getFaults(params)
      .then((response) => {
        if (response.status === 200) {
          setFaultsOptions(response?.data?.newFaults);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const validateCashBackImages = () => {
    let cashbackMethodsQuantity = parseFloat(watch3("cashbackMethodsQuantity"));
    let canPost = true;

    setErrorsDropzone((prevState) => {
      return {
        ...prevState,
        error1: false,
        error2: false,
        error3: false,
      };
    });

    for (let i = 1; i <= cashbackMethodsQuantity; i++) {
      const requiredMetods = paymentMethods?.filter((method) =>
        [
          metodosDePago?.CASH_BS,
          metodosDePago?.CASH_EUR,
          metodosDePago?.CASH_USD,
          metodosDePago?.PUNTO_DE_VENTA,
        ]?.includes(method?.name)
      );
      const method = filterOptionById(
        requiredMetods,
        watch3("returnedMethod" + i)
      );

      if (method && !watch3(`returnedReference${i}`)) {
        setError3(`returnedReference${i}`, {
          type: "custom",
          message: "Obligatorio",
        });
        canPost = false;
      }

      if (!cashBackImage[`image${i}`] && method) {
        notify(
          `Adjunte todos los comprobantes de pago de ${method?.name}`,
          "error"
        );
        canPost = false;
        setErrorsDropzone((prevState) => {
          return {
            ...prevState,
            [`error${i}`]: true,
          };
        });
      }
    }
    return canPost;
  };

  const calculateCashBack = () => {
    if (parseFloat(watch3("paid")) > parseFloat(watch3("amount0"))) {
      setValue3(
        "paidBsS",
        (parseFloat(watch3("paid")) * dollarRate)?.toFixed(2)
      );

      if (!watch3("cashbackMethodsQuantity")) {
        setValue3("cashbackMethodsQuantity", 1);
        let amountReturned =
          parseFloat(watch3(`amount0`)) - parseFloat(watch3("paid"));
        if (parseFloat(watch3(`amount1IGTF`))) {
          amountReturned = amountReturned + parseFloat(watch3(`amount1IGTF`));
        }
        amountReturned = amountReturned?.toFixed(2);
        setValue3("amountReturned", Math.abs(amountReturned));
        setValue3(
          "amountReturnedBsS",
          (parseFloat(watch3("amountReturned")) * dollarRate)?.toFixed(2)
        );
        setValue3(`returnedAmount1`, Math.abs(amountReturned));
        setValue3(
          `returnedAmountBsS1`,
          (parseFloat(watch3("amountReturned")) * dollarRate)?.toFixed(2)
        );
      }
    }
  };

  const validateCashBackTotal = () => {
    let cashbackMethodsQuantity = parseFloat(watch3("cashbackMethodsQuantity"));
    let amountReturned = parseFloat(watch3(`amountReturned`));
    let total = 0;
    for (let i = 1; i <= cashbackMethodsQuantity; i++) {
      total = total + parseFloat(watch3(`returnedAmount${i}`));
    }

    if (total !== amountReturned) {
      notify(
        "El la suma de los montos debe ser igual al monto a entregar",
        "error"
      );
      return false;
    }
    if (!watch3("returnedMethod1")) {
      // setError3(`returnedMethod1`, { type: 'custom', message: 'Obligatorio' });
      return false;
    } else {
      return true;
    }
  };

  const handleCashbackMethodsQuantity = () => {
    for (let i = 1; i <= 3; i++) {
      setValue3(`returnedMethod${i}`, "");
      setValue3(`returnedAmount${i}`, "");
      setValue3(`returnedAmountBsS${i}`, "");
      setCashBackImage((prevState) => {
        return {
          ...prevState,
          [`image${i}`]: "",
        };
      });
    }

    if (watch3("cashbackMethodsQuantity") === "1") {
      setValue3(`returnedAmount1`, watch3("amountReturned"));
      setValue3(
        `returnedAmountBsS1`,
        (parseFloat(watch3("amountReturned")) * dollarRate)?.toFixed(2)
      );
    }
  };

  const handleCashbackBs = (index) => {
    let cashbackMethodsQuantity = parseFloat(watch3("cashbackMethodsQuantity"));
    let amountReturned = parseFloat(watch3(`amountReturned`));

    setValue3(
      `returnedAmountBsS${index}`,
      (parseFloat(watch3(`returnedAmount${index}`)) * dollarRate)?.toFixed(2)
    );

    // Automatically set the amount for the last method
    if (index === cashbackMethodsQuantity - 1) {
      let paid = 0;
      for (let i = 1; i < cashbackMethodsQuantity; i++) {
        paid = paid + parseFloat(watch3(`returnedAmount${i}`));
      }

      if (amountReturned - paid <= 0) {
        notify(
          "El la suma de los montos no puede superar el vuelto a entregar",
          "error"
        );
        for (let j = 1; j <= cashbackMethodsQuantity; j++) {
          setValue3(`returnedAmount${j}`, 0);
          setValue3(`returnedAmountBsS${j}`, 0);
        }
        return null;
      }

      setValue3(
        `returnedAmount${cashbackMethodsQuantity}`,
        (amountReturned - paid)?.toFixed(2)
      );
      setValue3(
        `returnedAmountBsS${cashbackMethodsQuantity}`,
        (
          parseFloat(watch3(`returnedAmount${cashbackMethodsQuantity}`)) *
          dollarRate
        )?.toFixed(2)
      );
    }
  };

  const handleDrop = (event, index) => {
    let file = "";
    // File added on drop
    if (event?.dataTransfer?.files) {
      file = Array?.from(event?.dataTransfer?.files)[0];
    }

    let maxWeight = 5; //Peso en MB

    // File added on Click
    if (event?.target?.files?.length > 0) {
      file = event?.target?.files[0];
    }

    if (
      !["image/png", "image/jpg", "image/jpeg", "application/pdf"].includes(
        file.type
      )
    ) {
      notify("Agregar un formato valido de imagen", "error");
      return null;
    }
    if (file.size * 0.000001 > maxWeight) {
      notify(`La imagen no debe superar los ${maxWeight} MB`, "error");
    }
    setCashBackImage((prevState) => {
      return {
        ...prevState,
        [`image${index}`]: file,
      };
    });
  };

  const removeFile = (index) => {
    setCashBackImage((prevState) => {
      return {
        ...prevState,
        [`image${index}`]: "",
      };
    });
  };

  const updateLocationStatus = (reference) => {
    setValue2(`${reference}LocationStatus`, addressEnum?.OTHER);
    setValue2("caseKm", "");
  };

  // Function that preloads garage location as origin or destiny
  const handleLocation = (location, reference) => {
    if (
      location &&
      ![addressEnum?.OWN, addressEnum?.OTHER]?.includes(location)
    ) {
      let [filteredOption] = addressOption.filter((a) => a?._id === location);
      setValue2(`${reference}State`, filteredOption?.stateId);
      statesService
        .getCities(filteredOption?.stateId)
        .then((response) => {
          if (response.status === 200) {
            if (reference === referenceLocation?.ORIGIN) {
              setOriginCitiesOptions(response?.data?.cities);
            }
            if (reference === referenceLocation?.DESTINY) {
              setDestinyCitiesOptions(response?.data?.cities);
            }
          } else {
            notify(`${response.message}` || "error", "error");
          }
        })
        .catch(() => { });

      setTimeout(() => {
        setValue2(`${reference}City`, filteredOption?.cityId);
        if (referenceLocation?.ORIGIN === reference) {
          originRef.current.value = capitalize(filteredOption?.address);
        }
        if (referenceLocation?.DESTINY === reference) {
          destinyRef.current.value = capitalize(filteredOption?.address);
        }
      }, 1200);
    }
  };

  // Function that preloads garage location as origin or destiny
  const selectGarage = (e, reference) => {
    forceRecalulateDistance();
    const { value } = e?.target;
    // Preload GARAGE data
    if (value && ![addressEnum?.OWN, addressEnum?.OTHER]?.includes(value)) {
      handleLocation(value, reference);
    }
    // Own Value
    if (value === addressEnum?.OWN) {
      Promise.allSettled([
        getCities(clientSearch?.selected?.vehicle?.stateId, reference),
      ]).then((r) => {
        setTimeout(() => {
          setValue2(
            `${reference}State`,
            clientSearch?.selected?.vehicle?.stateId
          );
          setValue2(
            `${reference}City`,
            clientSearch?.selected?.vehicle?.cityId
          );

          if (referenceLocation?.ORIGIN === reference) {
            originRef.current.value = capitalize(
              clientSearch?.selected?.vehicle?.address
            );
          }
          if (referenceLocation?.DESTINY === reference) {
            destinyRef.current.value = capitalize(
              clientSearch?.selected?.vehicle?.address
            );
          }
        }, 1500);
      });
    }
  };

  const unSelectService = () => {
    // Si es seguimiento en viaje quitar el checkbox
    // Restaurar "Sin dirección destino" al quitar Cerrajeria
    if (availableServices?.selected?.code === afiliatedServices?.LOCKSMITH) {
      setValue2("withOutDestinyAddress", prevWithOutDestinyRef.current);
    }

    if (availableServices?.selected?.code === afiliatedServices?.SEG_VIAJE) {
      setValue2("segViaje", false);
    }

    let services = availableServices?.available;
    setSelectedBike("");
    services.forEach((e) => {
      e.selected = false;
      setAvailableServices((prevState) => {
        return {
          ...prevState,
          selected: "",
          available: [...services],
        };
      });
    });
  };

  const openMapModal = () => {
    if (
      !getValues2("originState") ||
      !getValues2("originCity") ||
      !originRef.current.value
    ) {
      notify("Ingrese datos de origen", "error");
      return null;
    }
    if (
      !getValues2("destinyState") ||
      !getValues2("destinyCity") ||
      !destinyRef.current.value
    ) {
      notify("Ingrese datos de destino", "error");
      return null;
    }

    setValue2("originAddress", originRef.current.value);
    setValue2("destinyAddress", destinyRef.current.value);

    setOrigin({
      lat: "",
      lng: "",
      address: originRef.current.value,
    });

    setDestiny({
      lat: "",
      lng: "",
      address: destinyRef.current.value,
    });
    setMapModalOpen(true);
  };

  const handleCloseModal = () => {
    setValue2("caseKm", route?.distance);
    setValue2("estimatedTime", route?.time);
    setMapModalOpen(false);
    setRoute((prevState) => {
      return {
        ...prevState,
        distance: "",
      };
    });
  };

  const selectBikeProvider = (e) => {
    setSelectedBike(e?.target?.value);
  };

  const getRecommendedProviders = () => {
    providersService
      .getProviders(filterParams({ type: "Cerrajero" }))
      .then((response) => {
        if (response.status === 200) {
          setRecommendedProvidersOptions(response?.data?.providers || []);
        } else {
          setRecommendedProvidersOptions([]);
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const getAVs = () => {
    providersService
      .getAVs()
      .then((response) => {
        if (response.status === 200) {
          setProvidersOptions(response?.data?.providers);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const startTowService = () => {
    if (!reason) {
      notify("Debe indicar un motivo de selección de la grúa", "info");
      return null;
    }

    const data = {
      case: _case?.selected?._id,
      reason: reason,
      approvedBy: watch7("authorizedBy"),
    };

    if (
      availableServices?.selected?.code === afiliatedServices?.craneExtended
    ) {
      data.useExtendedTow = true;
    }

    if (requiresRideryOtp) {
      data.enforceRideryOtp = false;
    } else {
      data.enforceRideryOtp = true;
    }

    if (!isLoading) {
      setIsloading(true);
      stagesService
        .createInitialTowStage(data)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            history.push("/services");
            notify(`Servicio creado en búsqueda de grúa`, "success");
            setIsloading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  };

  const refreshAfterCancel = () => {
    history.push("/services");
  };

  const registerPayment = () => {
    console.log("@ Register Payment", clientSearch?.selected);
    setValue3(
      "contact",
      clientSearch?.selected?.customer?.phonePrefix +
      "-" +
      clientSearch?.selected?.customer?.phoneNumber
    );
    setValue3("vehicleYear", clientSearch?.selected?.vehicle?.year);
    setValue3(
      "vehicleModel",
      capitalize(clientSearch?.selected?.vehicle?.model)
    );
    setValue3(
      "vehicleBrand",
      capitalize(clientSearch?.selected?.vehicle?.brand)
    );
    setValue3("vehiclePlate", exists(clientSearch?.selected?.vehicle?.plate));
    setValue3(
      "vehicleColor",
      capitalize(clientSearch?.selected?.vehicle?.color)
    );
    setValue3("estimatedTime", exists(_case?.selected?.estimatedTime));

    setValue3("paymentStatus", PaymentStatus?.N_A);
    setValue3("price", availableServices?.selected?.price);
    setValue3("pvp", 0);
    setValue3(
      "contact",
      clientSearch?.selected?.customer?.phonePrefix +
      "-" +
      clientSearch?.selected?.customer?.phoneNumber
    );
    setValue3("vehicleYear", clientSearch?.selected?.vehicle?.year);
    setValue3(
      "vehicleModel",
      capitalize(clientSearch?.selected?.vehicle?.model)
    );
    setValue3(
      "vehicleBrand",
      capitalize(clientSearch?.selected?.vehicle?.brand)
    );
    setValue3("vehiclePlate", exists(clientSearch?.selected?.vehicle?.plate));
    setValue3(
      "vehicleColor",
      capitalize(clientSearch?.selected?.vehicle?.color)
    );
    setValue3("estimatedTime", exists(_case?.selected?.estimatedTime));

    if (clientSearch?.selected?.papClient) {
      setValue3(
        "contact",
        watch2("contactPhone") || ""
      );
      setValue3("vehicleYear", watch2("vehicleYear"));
      setValue3("vehiclePlate", watch2("vehiclePlate"));
      setValue3(
        "vehicleModel",
        filterOptionById(modelOptions, watch2("vehicleModel"))?.name
      );
      setValue3(
        "vehicleBrand",
        filterOptionById(brandOptions, watch2("vehicleBrand"))?.name
      );
      setValue3("vehicleColor", capitalize(watch2("vehicleColor")));
      setValue3("estimatedTime", exists(_case?.selected?.estimatedTime));
    }

    if (
      [
        afiliatedServices?.BATT_SALE,
        particularServices?.BATT_SALE_PART,
      ].includes(availableServices?.selected?.code)
    ) {
      setValue3("price", availableServices?.selected?.price);
      setValue3("pvp", watch6("price"));
      setValue3("paymentMethods", 1);
    }
    setOpenPayModal(true);

    if (
      [afiliatedServices?.ESCORT].includes(availableServices?.selected?.code)
    ) {
      setValue3("paymentStatus", PaymentStatus?.N_A);
      setValue3("pvp", 0);
    }

    if (isLocksmithService(availableServices?.selected)) {
      // Cerrajeria: el costo lo carga el operador cuando llega la factura
      setLocksmithPaymentDefaults(setValue3);
    } else {
      setValue3("isLocksmith", false);
      // Add 30% extra charge if the provider has a price multiplier
      const provider = selectableProviders.find((p) => p._id === selectedBike);
      const multiplier = 1 + provider?.priceMultiplier / 100;
      setValue3("price", (availableServices?.selected?.price * multiplier).toFixed(2));
    }

    if (clientSearch?.selected?.ivaPercentage) {
      setValue3("ivaPercentage", clientSearch?.selected?.ivaPercentage);
      setValue3('ivaAmount', clientSearch?.selected?.ivaAmount);
      setValue3('addIva', true);
    }

  };

  // Load payemnt methods and refactor JSON
  let loadPaymentForms = (params) => {
    let payments = [];
    // lOOP through every payment method
    for (let i = 0; i < parseInt(getValues3("paymentMethods")); i++) {
      let payment = {
        method: params[`method` + i.toString()],
        reference: params[`reference` + i.toString()],
        amount: params[`amount` + i.toString()],
        amountBsS: params[`amountBsS` + i.toString()],
      };
      if (
        [
          metodosDePago?.CASH_USD,
          metodosDePago?.CASH_BS,
          metodosDePago?.CASH_EUR,
        ].includes(
          filterOptionById(paymentMethods, params[`method` + i.toString()])
            ?.name
        )
      ) {
        payment.cashReceiver = params[`cashReceiver` + i.toString()];
      }

      if (params[`accHolder` + i.toString()]) {
        payment.accHolder = params[`accHolder` + i.toString()];
      }
      payments.push(payment);
    }

    // "REmove unwanted params from JSON"
    let words = [
      "method",
      "reference",
      "accHolder",
      "amount",
      "amountBsS",
      "paymentMethod",
    ];
    for (const key in params) {
      for (var i = 0, ln = words.length; i < ln; i++) {
        if (key.indexOf(words[i]) !== -1) {
          delete params[key];
        }
      }
    }
    params.payments = payments;
    return params;
  };

  const validateTotalPayment = (data) => {
    if (
      (parseFloat(watch3("pvp")) >= 0 ||
        parseFloat(watch3("amountHandling")) >= 0 ||
        parseFloat(watch3("amountExcess")) >= 0) &&
      ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR]?.includes(
        watch3("paymentStatus")
      )
    ) {
      let totalSum = 0;
      for (let i = 0; i < watch3("paymentMethods"); i++) {
        totalSum = totalSum + parseFloat(watch3(`amount${i}`));
      }
      if (
        totalSum !==
        parseNull(watch3("pvp")) +
        parseNull(watch3("amountHandling")) +
        parseNull(watch3("amountExcess")) +
        parseNull(watch3("ivaAmount"))
      ) {
        notify(
          "Monto a pagar por el cliente y la suma de los pagos no coinciden",
          "info"
        );
        return false;
      } else return true;
    } else return true;
  };

  const createAVService = handleSubmit3(async (data) => {
    if (isLocksmithService(availableServices?.selected)) {
      if (isLoading) return;
      setIsloading(true);
      createLocksmithService({
        caseId: _case?.selected?._id,
        provider: selectedBike,
        data,
      })
        .then(({ created, saved, response }) => {
          if (!created) {
            notify(
              `${response?.data?.message || response?.message || "No pudimos crear el servicio de cerrajería"}`,
              "error"
            );
            setIsloading(false);
            return;
          }
          notify(
            saved
              ? `Servicio de cerrajería creado con exito`
              : `El servicio se creó, pero no se pudo guardar el costo o la factura de cerrajería`,
            saved ? "success" : "error"
          );
          history.push("/services");
          setIsloading(false);
        })
        .catch(() => setIsloading(false));
      return;
    }

    if (!validatePaymentRefLenght(data, setError3, paymentMethods)) {
      return;
    }

    let isCash =
      watch3("method0") ===
      filterOption(paymentMethods, metodosDePago?.CASH_USD)?._id;

    if (!validateTotalPayment(data)) {
      return null;
    }

    if (isCash) {
      calculateCashBack();

      if (parseFloat(watch3("cashbackMethodsQuantity")) > 0) {
        // Validate the total of the cashback
        // Validate that all images are up
        if (!validateCashBackTotal() || !validateCashBackImages()) {
          return null;
        }
      }
    }

    let dataToPost = { ...data };
    dataToPost = loadPaymentForms(dataToPost);
    delete dataToPost?.contact;
    delete dataToPost?.vehicleBrand;
    delete dataToPost?.vehicleColor;
    delete dataToPost?.vehicleYear;
    delete dataToPost?.vehicleModel;
    delete dataToPost?.estimatedTime;
    delete dataToPost?.vehiclePlate;

    dataToPost.product = availableServices?.selected?._id;
    dataToPost.case = _case?.selected?._id;
    dataToPost.provider = selectedBike; // // Unicamente para casos particulares

    let fileToPost = appendFile(dataToPost);
    if (!isLoading && fileToPost) {
      setIsloading(true);
      servicesService
        .createAVService(fileToPost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`AV creado con exito`, "success");
            history.push("/services");
            setIsloading(false);
          } else {
            setShowErrorAPI(true);
            notify(
              `${response?.data?.message || response?.message || "No pudimos validar el pago, por favor revisa los datos ingresados"}`,
              "error"
            );
            setIsloading(false);
          }
        })
        .catch((error) => {
          setShowErrorAPI(true);
          setIsloading(false);
        });
    }
  });

  const changePaymentStatus = () => {
    setValue3("authorizedBy", "");

    if (
      [
        afiliatedServices?.BATT_SALE,
        particularServices?.BATT_SALE_PART,
      ].includes(availableServices?.selected?.code)
    ) {
      return;
    }

    if (watch3("paymentStatus") === PaymentStatus?.COURTESY) {
      setValue3("pvp", 0);
      return null;
    }
    if (watch3("paymentStatus") === PaymentStatus?.N_A) {
      setValue3("pvp", 0);
      return null;
    } else {
      setValue3("pvp", "");
      return null;
    }
  };

  // If the payment method is set to 0 clear the form for the N payment methods
  const restorePaymentMethods = () => {
    if (parseFloat(watch3("pvp")) === 0) {
      for (let i = 0; i < parseInt(watch3("paymentMethods")); i++) {
        resetField3(`method${i}`);
        resetField3(`reference${i}`);
        resetField3(`paymentMethod${i}`);
        resetField3(`amount${i}`);
        resetField3(`amountBsS${i}`);
      }
      resetField3("paymentMethods");
    }
    // setValue3()
  };

  const validateMaxPaymentMethods = () => {
    if (watch3("paymentMethods") > 5) {
      setValue3("paymentMethods", 5);
      notify("El limite permitido es de 5 métodos de pago", "info");
    }
  };

  const appendFile = (data) => {
    const formData = new FormData();
    formData.append("case", data?.case);
    formData.append("product", data?.product);
    formData.append("provider", data?.provider);
    formData.append("price", data?.price ?? 0);
    formData.append("pvp", data?.pvp);
    formData.append("paymentStatus", data?.paymentStatus);

    if (
      [
        afiliatedServices?.BATT_SALE,
        particularServices?.BATT_SALE_PART,
      ].includes(availableServices?.selected?.code)
    ) {
      formData.append("battery", watch6("battery"));
    }

    if (data?.authorizedBy) {
      formData.append("authorizedBy", data?.authorizedBy);
    }

    // SI es cuentas por cobrar o NA no anexar datos ni comprobantes de pago

    if (
      ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR]?.includes(
        watch3("paymentStatus")
      )
    ) {
      for (var i = 0; i < data?.payments.length; i++) {
        formData.append(`payments[${i}][amount]`, data?.payments[i].amount);
        formData.append(
          `payments[${i}][amountBsS]`,
          data?.payments[i].amountBsS
        );
        formData.append(`payments[${i}][method]`, data?.payments[i].method);
        formData.append(
          `payments[${i}][reference]`,
          data?.payments[i].reference
        );
        if (data?.payments[i].accHolder) {
          formData.append(
            `payments[${i}][accHolder]`,
            data?.payments[i].accHolder
          );
        }
        if (
          [
            metodosDePago?.CASH_USD,
            metodosDePago?.CASH_BS,
            metodosDePago?.CASH_EUR,
          ].includes(
            filterOptionById(paymentMethods, data?.payments[i]?.method)?.name
          )
        ) {
          formData.append(
            `payments[${i}][cashReceiver]`,
            data?.payments[i]?.cashReceiver
          );
        }

        if (data.addIva) {
          formData.append(`payments[${i}][ivaPercentage]`, data?.ivaPercentage);
          formData.append(`payments[${i}][ivaAmount]`, data.ivaAmount);
        }

        if (showErrorAPI && watch3(`skipApiValidationError${i}`)) {
          formData.append(
            `payments[${i}][skipApiValidationError]`,
            watch3(`skipApiValidationError${i}`)
          );
        }
      }

      for (let i = 0; i < parseInt(watch3("paymentMethods")); i++) {
        formData.append(`paymentEvidence`, fileUploaded[i]);
      }
    }

    // Load as many files as payment methods we have
    if (
      fileUploaded.length !== parseFloat(watch3("paymentMethods")) &&
      parseFloat(watch3("paymentMethods")) > 0 &&
      ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR]?.includes(
        watch3("paymentStatus")
      )
    ) {
      notify("Ingrese comprobantes de pago", "info");
      return null;
    }
    if (
      parseFloat(watch3("pvp")) &&
      ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR]?.includes(
        watch3("paymentStatus")
      )
    ) {
      let totalSum = 0;
      for (let i = 0; i < data?.payments.length; i++) {
        totalSum = totalSum + parseFloat(data?.payments[i].amount);
      }
      const pvpMoreIvaAmount = parseNull(watch3("pvp")) + parseNull(watch3("ivaAmount"));
      if (totalSum !== pvpMoreIvaAmount) {
        notify(
          "Monto a pagar por el cliente y suma de los pagos no coinciden",
          "info"
        );
        return null;
      }
    }

    // Vueltos
    for (let j = 0; j < parseFloat(watch3("cashbackMethodsQuantity")); j++) {
      formData.append(`paymentChanges[${j}][paid]`, data[`paid`]);
      formData.append(
        `paymentChanges[${j}][method]`,
        data[`returnedMethod${j + 1}`]
      );
      formData.append(
        `paymentChanges[${j}][amount]`,
        data[`returnedAmount${j + 1}`]
      );
      formData.append(
        `paymentChanges[${j}][amountBsS]`,
        data[`returnedAmountBsS${j + 1}`]
      );
      if (data[`returnedReference${j + 1}`]) {
        formData.append(
          `paymentChanges[${j}][ref]`,
          data[`returnedReference${j + 1}`]
        );
      }
      formData.append(
        `paymentChanges[${j}][hasEvidence]`,
        data[`returnedReference${j + 1}`] ? true : false
      );
      if (cashBackImage[`image${j + 1}`]) {
        formData.append(
          `paymentChangeEvidence`,
          cashBackImage[`image${j + 1}`]
        );
      }
    }

    return formData;
  };

  const handleCancelService = (incidence) => {
    if (incidence) {
      membershipService
        .getCancelReason(
          resolveCancelReasonType(incidence, {
            isPapClient: !!clientSearch?.selected?.papClient,
          })
        )
        .then((response) => {
          if (response.status === 200) {
            setShowCancelService({
              cancelOptions: response?.data?.newCancellationReasons,
              show: !showCancelService.show,
              selected: incidence ? incidence : "",
            });
          } else {
            notify(`${response.message}` || "error", "error");
          }
        })
        .catch((error) => { });
    } else {
      setShowCancelService({
        cancelOptions: [],
        show: !showCancelService.show,
        selected: incidence ? incidence : "",
      });
    }
  };

  const getPaymentMethods = () => {
    productService
      .getPaymentMethods("operations")
      .then((response) => {
        if (response.status === 200) {
          setPaymentMethods(response?.data);
          setFilteredMethods(
            response?.data?.filter((d) => d?.name !== metodosDePago?.CASH_USD)
          );
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const getVehicleBrands = () => {
    vehicleService
      .getVehicleBrands()
      .then((response) => {
        if (response.status === 200) {
          setBrandOptions(response?.data?.vehicleBrands);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const handleModelOptsions = (brand) => {
    vehicleService
      .getVehicleModels(brand ? brand : watch2("brand"))
      .then((response) => {
        if (response.status === 200) {
          setModelOptions(response?.data?.models);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const getLastServices = (membershipId) => {
    membershipService
      .getLastServices(membershipId)
      .then((response) => {
        if (response.status === 200) {
          setServiceHistory(response?.data?.latestServices);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const getPAPLastServices = (membershipId) => {
    servicesService
      .getLatestPap(membershipId)
      .then((response) => {
        if (response.status === 200) {
          setServiceHistory(response?.data?.latestServices);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const getInternalTowServices = () => {
    let params = {
      type: "all",
    };

    providersService
      .getInternalTowServices(params)
      .then((response) => {
        if (response.status === 200) {
          setShowCraneCounterModal((prevState) => {
            return {
              ...prevState,
              data: response?.data,
            };
          });
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const getCashReceivers = () => {
    cashReceiverService
      .getCashReceivers()
      .then((response) => {
        if (response.status === 200) {
          setCashReceiverOptions(response?.data?.cashReceivers);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((e) => {
        console.log("Error trayendo las cajas de efectivo", e);
      });
  };

  const getAdminSupervisors = () => {
    usersService
      .getAdminSupervisors()
      .then((response) => {
        if (response.status === 200) {
          let data = [];

          for (let i = 0; i < response?.data?.users.length; i++) {
            data.push({
              _id: response?.data?.users[i]?.fullName,
              name: response?.data?.users[i]?.fullName,
            });
          }
          setSupervisors(data);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const openDocumentModal = (src, service) => {
    setShowCraneCounterModal((prevState) => {
      return {
        ...prevState,
        show: !showCraneCounterModal?.show,
        src: !showCraneCounterModal?.src ? src : "",
        service: service,
      };
    });
  };

  const zoomDocumentModal = (zoom) => {
    setShowCraneCounterModal((prevState) => {
      return {
        ...prevState,
        zoom: zoom,
      };
    });
  };

  const handleReason = (e) => {
    setReason(e?.target?.value);
  };

  const paymentStatusOptions = () => {
    if (
      [
        afiliatedServices?.tire,
        afiliatedServices?.battery,
        afiliatedServices?.accompaniment,
        afiliatedServices?.ESCORT,
      ].includes(availableServices?.selected?.code)
    ) {
      return [{ name: PaymentStatus?.N_A, _id: PaymentStatus?.N_A }];
    }
    if (
      [
        afiliatedServices?.BATT_SALE,
        particularServices?.BATT_SALE_PART,
      ].includes(availableServices?.selected?.code)
    ) {
      return PaymentStatusOptions.filter((e) => e._id !== PaymentStatus?.N_A);
    } else {
      return PaymentStatusOptions;
    }
  };

  useEffect(() => {
    getInternalTowServices();
    getPaymentMethods();
    getVehicleBrands();
    getStates();
    getFaults();
    getAVs();
    getGarageLocation();
    getCashReceivers();
    getAdminSupervisors();
  }, []);

  // Holds the data parsed from the clipboard template until the membership
  // search + select cycle finishes — at that point the IncidenceDetailForm
  // mounts and we can safely setValue2 the incidence fields.
  const [pendingTemplate, setPendingTemplate] = useState(null);
  // The cities catalogue loads asynchronously after we pick a state, so we
  // remember the city *name* and resolve it from a later render once the
  // matching options have arrived.
  const [pendingCity, setPendingCity] = useState({ origin: "", destiny: "" });

  useEffect(() => {
    if (!pendingCity.origin || !originCitiesOptions?.length) return;
    const match = findOptionLoose(originCitiesOptions, pendingCity.origin);
    if (match?._id) {
      setValue2("originCity", match._id);
      setPendingCity((p) => ({ ...p, origin: "" }));
    }
  }, [originCitiesOptions, pendingCity.origin, setValue2]);

  useEffect(() => {
    if (!pendingCity.destiny || !destinycitiesOptions?.length) return;
    const match = findOptionLoose(destinycitiesOptions, pendingCity.destiny);
    if (match?._id) {
      setValue2("destinyCity", match._id);
      setPendingCity((p) => ({ ...p, destiny: "" }));
    }
  }, [destinycitiesOptions, pendingCity.destiny, setValue2]);

  // Applies the parsed template once the membership has been fetched and
  // the IncidenceDetailForm is rendered. Runs only when both pieces are
  // present so the setValue2 calls don't get lost on an unmounted form.
  useEffect(() => {
    if (!pendingTemplate || !clientSearch?.selected) return;

    const parsed = pendingTemplate;
    const isPap = !!clientSearch?.selected?.papClient;
    const isF2 =
      clientSearch?.selected?.code?.code === "F2" &&
      !clientSearch?.selected?.vehicle?.brand;

    if (isPap) {
      if (parsed.firstName) setValue2("firstName", capitalize(parsed.firstName));
      if (parsed.lastName) setValue2("lastName", capitalize(parsed.lastName));
      if (parsed.phonePrefix || parsed.phoneNumber) {
        setValue2(
          "phone",
          formatPhoneForInput(parsed.phonePrefix, parsed.phoneNumber)
        );
      }
      if (parsed.vehiclePlate) setValue2("vehiclePlate", parsed.vehiclePlate);
    }
    if (isF2 && parsed.vehiclePlate) {
      setValue2("vehiclePlate", parsed.vehiclePlate);
    }

    if (parsed.phonePrefix || parsed.phoneNumber) {
      setValue2(
        "contactPhone",
        formatPhoneForInput(parsed.phonePrefix, parsed.phoneNumber)
      );
    }

    if (parsed.faultType && faultsOptions?.length) {
      const fault = findOptionLoose(faultsOptions, parsed.faultType);
      if (fault?._id) {
        setValue2("customerFailureReason", fault._id);
      } else {
        notify(
          `No se encontró la avería "${parsed.faultType}" en el catálogo`,
          "info"
        );
      }
    }
    const description = [parsed.faultType, parsed.faultDetail]
      .filter((v) => v && v.trim())
      .join(" - ");
    if (description) setValue2("customerFailureDescription", description);

    const fillLocation = (refKey) => {
      const isOrigin = refKey === referenceLocation.ORIGIN;
      const stateName = isOrigin ? parsed.originState : parsed.destinyState;
      const cityName = isOrigin ? parsed.originCity : parsed.destinyCity;
      const address = isOrigin ? parsed.originAddress : parsed.destinyAddress;
      const link = isOrigin
        ? parsed.originLocationLink
        : parsed.destinyLocationLink;

      setValue2(`${refKey}LocationStatus`, addressEnum.OTHER);
      if (isOrigin) setValue2("isOriginBasement", false);

      if (stateName && statesOptions?.length) {
        const stateMatch = findOptionLoose(statesOptions, stateName);
        if (stateMatch?._id) {
          setValue2(`${refKey}State`, stateMatch._id);
          getCities(stateMatch._id, refKey);
          if (cityName) {
            setPendingCity((p) => ({ ...p, [refKey]: cityName }));
          }
        } else {
          notify(
            `No se encontró el estado "${stateName}" en el catálogo`,
            "info"
          );
        }
      }

      if (address) {
        setValue2(`${refKey}Address`, address);
        const refNode = isOrigin
          ? originRef?.current
          : destinyRef?.current;
        if (refNode) refNode.value = address;
        updateLocationStatus(refKey);
      }

      if (link) setValue2(`${refKey}LocationLink`, link);
    };

    fillLocation(referenceLocation.ORIGIN);
    if (!watch2("withOutDestinyAddress")) {
      fillLocation(referenceLocation.DESTINY);
    }

    notify("Datos pegados desde la plantilla", "success");
    setPendingTemplate(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingTemplate, clientSearch?.selected]);

  const handlePasteTemplate = async () => {
    let raw = "";
    try {
      if (navigator?.clipboard?.readText) {
        raw = await navigator.clipboard.readText();
      } else {
        raw = window.prompt("Pega aquí el resumen de la incidencia:") || "";
      }
    } catch (e) {
      raw = window.prompt("Pega aquí el resumen de la incidencia:") || "";
    }
    if (!raw.trim()) {
      notify("No se encontró texto en el portapapeles", "error");
      return;
    }

    // The shared parser throws when Cliente / Teléfono / Dirección origen are
    // missing, but for the affiliated flow the only field we strictly need
    // is the plate (everything else is filled by the membership lookup), so
    // accept the partial payload when it carries one.
    let parsed;
    try {
      parsed = parseIncidenceTemplate(raw);
    } catch (e) {
      if (e?.code === "MISSING_FIELDS" && e?.partial?.vehiclePlate) {
        parsed = e.partial;
      } else {
        notify(
          "La plantilla no contiene una placa válida del vehículo",
          "error"
        );
        return;
      }
    }

    const plate = parsed?.vehiclePlate?.trim();
    if (!plate) {
      notify("La plantilla no contiene una placa válida del vehículo", "error");
      return;
    }

    // Reflect the plate in the search input so the user sees what's happening.
    setClientSearch((prevState) => ({
      ...prevState,
      searchParam: plate,
      selected: "",
      options: [],
      isOpen: false,
    }));

    const results = await getMembership(plate);
    if (!results || results.length === 0) {
      notify(`No se encontró ninguna membresía para la placa ${plate}`, "info");
      return;
    }

    // Pick the first record whose plate matches; fall back to the first hit
    // when the API didn't return a plate field (e.g. PAP results).
    const normalisedPlate = plate.toUpperCase();
    const matched =
      results.find(
        (r) => (r?.plate || r?.vehicle?.plate || "").toUpperCase() === normalisedPlate
      ) || results[0];

    setPendingTemplate(parsed);
    selectClient(matched);
  };

  const { handleAddIva } = useIvaCalculation({
    watch: watch3,
    setValue: setValue3,
  });

  return (
    <>
      <CraneCounter
        showCraneCounterModal={showCraneCounterModal}
        openDocumentModal={openDocumentModal}
        zoomDocumentModal={zoomDocumentModal}
      />
      <LoadSpinner label={"Cargando"} show={isLoading} />
      {availableServices?.selected?.code === afiliatedServices?.LOCKSMITH ? (
        <MessageLocksmithModal
          showSMSModal={showSMSModal}
          handleClose={openSMSModal}
          caseInfo={caseInfo}
          action={registerPayment}
          service={availableServices?.selected}
        />
      ) : (
        <MessageAVModal
          showSMSModal={showSMSModal}
          handleClose={openSMSModal}
          caseInfo={caseInfo}
          action={
            [
              afiliatedServices?.BATT_SALE,
              particularServices?.BATT_SALE_PART,
            ].includes(availableServices?.selected?.code) && !watch6("battery")
              ? ""
              : registerPayment
          }
          service={availableServices?.selected}
        />
      )}
      <BatterySaleModal
        showSMSModal={batterySaleModal}
        handleClose={handleBatterySaleModal}
        register={register6}
        errors={errors6}
        onChange={{ handleBatteryChange: handleBatteryChange }}
        options={{
          batteryOptions: batteryOptions,
        }}
        action={acceptBatterySale}
      />
      <MessageTowModal
        showSMSModal={showSMSTowModal}
        handleClose={openSMSTowModal}
        caseInfo={caseInfo}
        action={startTowService}
      />
      <CreateAVModal
        show={openPayModal}
        register={register3}
        openPayModal={openPayModal}
        handleClose={() => setOpenPayModal()}
        createAVService={createAVService}
        errors={errors3}
        options={{
          paymentMethods: paymentMethods,
          PaymentStatusOptions: paymentStatusOptions(),
          authorizedByOptions: supervisors,
          filteredMethods: filteredMethods,
          cashReceiverOptions: cashReceiverOptions,
        }}
        onChange={{
          changePaymentStatus: changePaymentStatus,
          restorePaymentMethods: restorePaymentMethods,
          setBsRate: setBsRate,
          validateMaxPaymentMethods: validateMaxPaymentMethods,
          handleCashbackMethodsQuantity: handleCashbackMethodsQuantity,
          handleCashbackBs: handleCashbackBs,
          setIsloading: setIsloading,
          handleAddIva: handleAddIva,
        }}
        battery={[
          afiliatedServices?.BATT_SALE,
          particularServices?.BATT_SALE_PART,
        ].includes(availableServices?.selected?.code)}
        watch={watch3}
        setValue={setValue3}
        setFileUploaded={setFileUploaded}
        fileUploaded={fileUploaded}
        bsDisabled={bsDisabled}
        handleDrop={handleDrop}
        cashBackImage={cashBackImage}
        removeFile={removeFile}
        errorsDropzone={errorsDropzone}
        showErrorAPI={showErrorAPI}
      />

      <FollowUpModal
        show={followUpModal}
        register={register5}
        handleClose={() => setFollowUpModal()}
        errors={errors5}
        onChange={{ restartTracking: restartTracking }}
        watch={watch5}
        control={control5}
        action={startFolloUpService}
        edit={editFolloUpService}
        acceptFollowing={acceptFollowing}
      />

      <CancelCaseModal
        showCancelCase={showCancelService}
        handleClose={() => handleCancelService()}
        refresh={refreshAfterCancel}
      />
      <Header />
      <ScheduleServicesModal
        show={showSchedule.show}
        handleClose={() =>
          setShowSchedule({
            ...showSchedule,
            show: false,
            battery: false,
          })
        }
        register={register4}
        control={control4}
        errors={errors4}
        action={scheduleService}
        t={t}
      />
      <div className="container">
        <div className="card incidence-card">
          <div className="buttons-container">
            <span></span>
            <ActionButton
              label={`Incidencia Particular`}
              action={() => history.push("/incidence/create/particular")}
            />
          </div>
          <div className="title-center-component">
            <h4>Nueva Incidencia</h4>
            <h5>{`Cliente Afiliado`}</h5>
          </div>
          <IncidenceSearch
            clientSearch={clientSearch}
            onChange={handleClientSearchChange}
            search={getMembership}
            selectClient={selectClient}
            type={clientTypes.AFFILIATED}
            onPasteTemplate={handlePasteTemplate}
          />

          {clientSearch?.selected && (
            <ClientDetail membership={clientSearch?.selected} />
          )}

          {canCreateIncidence(clientSearch?.selected) && (
            <IncidenceDetailForm
              register={register2}
              createCase={createAffiliatedCase}
              editCase={editAffiliatedCase}
              errors={errors2}
              setValue={setValue2}
              getValues={getValues2}
              watch={watch2}
              suggestion={{
                originRef: originRef,
                destinyRef: destinyRef,
              }}
              onChange={{
                getCities: getCities,
                selectGarage: selectGarage,
                clearDestinyData: clearDestinyData,
                handleSegViaje: handleSegViaje,
                clearThirdPartyData: clearThirdPartyData,
                forceRecalulateDistance: forceRecalulateDistance,
                updateLocationStatus: updateLocationStatus,
                getVehicleModels: handleModelOptsions,
              }}
              options={{
                statesOptions: statesOptions,
                originCitiesOptions: originCitiesOptions,
                destinycitiesOptions: destinycitiesOptions,
                faultsOptions: faultsOptions,
                addressOption: addressOption,
                vehicleBrandOptions: brandOptions,
                vehicleModelOptions: modelOptions,
              }}
              openMapModal={openMapModal}
              _case={_case?.selected}
              clientSearch={clientSearch}
              control={control2}
              lockWithOutDestinyAddress={
                availableServices?.selected?.code ===
                afiliatedServices?.LOCKSMITH
              }
            />
          )}

          <MapModal
            show={mapModalOpen}
            handleClose={handleCloseModal}
            origin={origin}
            setOrigin={setOrigin}
            destiny={destiny}
            setDestiny={setDestiny}
            route={route}
            setRoute={setRoute}
          />

          {_case?.selected && (
            <AvailableServices
              availableServices={availableServices}
              selectService={selectService}
            />
          )}

          {_case?.selected && availableServices?.selected && (
            <SelectedServices
              providersOptions={providersOptions}
              recommendedProvidersOptions={recommendedProvidersOptions}
              availableServices={availableServices}
              unSelectService={unSelectService}
              value={selectedBike}
              onChange={selectBikeProvider}
              openSMSModal={openSMSModal}
              openSMSTowModal={openSMSTowModal}
              handleReason={handleReason}
              reason={reason}
              clientType={clientTypes?.AFFILIATED}
            />
          )}

          {_case?.selected && availableServices?.selected && requiresRideryOtp && (
            <div className="row">
              {![0].includes(rideryOtpStatus) && (
                <>
                  <Input
                    bootstrap={"col-12 col-md-3"}
                    label={"Autorizado por *"}
                    type={"select"}
                    options={supervisors}
                    name={"authorizedBy"}
                    register={register7}
                    placeholder={""}
                    errors={errors7?.authorizedBy?.message}
                    disabled={[2].includes(rideryOtpStatus)}
                  />
                  <Input
                    bootstrap={"col-12 col-md-3"}
                    label={"Código OTP *"}
                    type={"text"}
                    name={"code"}
                    register={register7}
                    placeholder={""}
                    errors={errors7?.code?.message}
                    disabled={[2].includes(rideryOtpStatus)}
                  />
                </>
              )}
              {[1].includes(rideryOtpStatus) && (
                <div className="col-12 col-md-6" style={{ textAlign: "center" }}>
                  <p>
                    Primer servicio de grúa para afiliado del canal Ridery:
                    se requiere autorización con código OTP antes de iniciar
                    el servicio.
                  </p>
                  <div className="buttons-center-container">
                    {!watch7("code") ? (
                      <ActionButton
                        label="Solicitar código de autorización"
                        action={() => requestRideryOtp()}
                      />
                    ) : (
                      <ActionButton
                        label="Validar código de autorización"
                        action={() => validateRideryOtp()}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          {_case?.selected && availableServices?.selected && (
            <HandleCaseButtons
              setShowSchedule={setShowSchedule}
              handleScheduleBattery={handleScheduleBattery}
              startTowService={startTowService}
              selectedBike={selectedBike}
              service={availableServices?.selected}
              _case={_case?.selected}
              handleCancelService={handleCancelService}
              registerPayment={registerPayment}
              openModals={{
                openSMSTowModal: openSMSTowModal,
                openSMSModal: openSMSModal,
                openFollowUpModal: openFollowUpModal,
                handleBatterySaleModal: handleBatterySaleModal,
              }}
              bikerData={getOption(selectedBike, selectableProviders)}
              otpBlocked={requiresRideryOtp && ![2].includes(rideryOtpStatus)}
            />
          )}

          {clientSearch?.selected && clientSearch?.selected !== notFound && (
            <ServiceHistory serviceHistory={serviceHistory} />
          )}
        </div>
      </div>
    </>
  );
};

export const CaseDetail = (props) => {
  const { title, selectedCase } = props;
  return (
    <div className="incidence-table-section-container">
      <div className="filter-button-container"></div>
      <div className="buttons-container">
        <h6>{title}</h6>
      </div>
      <div className="row">
        <div className="col-12 col-lg-6 col-xl-4">
          <p>
            <b>Avería: </b> {selectedCase?.fault?.description} <br />
            <b>Caso Nro: </b> {selectedCase?.caseId}
            <br />
            {/* <b>Código de servicio: </b> CCCT15-0024435 */}
            <b>Operador: </b>
            {selectedCase?.user?.firstName} {selectedCase?.user?.lastName}
          </p>
        </div>
      </div>
    </div>
  );
};
